import AppContent from "./AppContent";
import AppFooter from "./AppFooter";
import AppHeader from "./AppHeader";
import AppSidebar from "./AppSidebar";
import AppContentWaitress from "./AppContentWaitress";
import AppContentKasir from "./AppContentKasir";
import AppContentKitchen from "./AppContentKitchen";
import AppContentFastFood from "./AppContentFastFood";

export {
  AppContent,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppContentWaitress,
  AppContentKasir,
  AppContentKitchen,
  AppContentFastFood,
};
